import React, { useRef, useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import MonacoEditor, { loader } from '@monaco-editor/react';
import Spin from '../spin';
import './index.less';
const Loading = (props) => {
    return (<div className="monaco-loading-container">
            <Spin size="large" {...props}/>
        </div>);
};
function CodePanel(props, ref) {
    const editorRef = useRef();
    const [code, setCode] = useState();
    let { value, width, height, readOnly = false, language = 'json', options = {}, 
    // strict = true,
    onChange = () => { }, theme, } = props;
    // you can configure the locales
    useImperativeHandle(ref, () => ({
        getValue: () => {
            // if (strict) return JSON.parse(editorRef.current.getValue());
            return editorRef.current.getValue();
        },
    }));
    useEffect(() => {
        try {
            // if (strict === true) {
            //     setCode(JSON.stringify(value, null, 4));
            // } else {
            setCode(value);
            // }
        }
        catch (e) {
            // ignore
            throw new Error(e);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value, language]);
    return (<div className="monaco-editor-container">
            <MonacoEditor width={width} height={height} theme={theme === 'light' ? 'vs' : 'hc-black'} language={language} loading={<Loading />} value={code} options={Object.assign({ wrappingIndent: 'deepIndent', readOnly: readOnly, automaticLayout: true, autoIndent: true, formatOnType: true, formatOnPaste: true, scrollBeyondLastLine: false, renderControlCharacters: false, minimap: {
                enabled: false,
            } }, options)} onMount={(editor, monaco) => {
            editorRef.current = editor;
        }} onChange={(newValue, e) => {
            onChange(newValue);
        }}/>
        </div>);
}
export default forwardRef(CodePanel);
export { loader };
